import React from 'react'
import styled from 'styled-components'
import SVG from 'react-inlinesvg'
import { breakpointFrom, breakpointUpTo } from 'utils/breakpoints'

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const StyledIlluWrapper = styled.figure`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: ${({ theme }) => theme.space[0]};
  ${({ theme }) => breakpointUpTo(theme.breakpoints.md)} {
    margin-bottom: ${({ theme }) => theme.space[1]};
  }
  svg {
    ${({ theme }) => breakpointUpTo(theme.breakpoints.md)} {
      height: 88px;
      width: auto;
    }
  }
`

const StyledHeading = styled.h3`
  ${({ theme }) => theme.typography.SmH3}
  ${({ theme }) => breakpointFrom(theme.breakpoints.md)} {
    ${({ theme }) => theme.typography.MedH3}
  }
  ${({ theme }) => breakpointFrom(theme.breakpoints.lg)} {
    ${({ theme }) => theme.typography.LrgH3}
  }
  ${({ theme }) => breakpointFrom(theme.breakpoints.xl)} {
    ${({ theme }) => theme.typography.XLH3}
  }
  text-align: center;
`

const StyledDescription = styled.p`
  max-width: 340px;
  ${({ theme }) => theme.typography.SmBody1};
  text-align: center;
  margin-top: ${({ theme }) => theme.space[0]};
  ${({ theme }) => breakpointFrom(theme.breakpoints.md)} {
    margin-top: ${({ theme }) => theme.space[1]};
    ${({ theme }) => theme.typography.MedBody1}
  }
  ${({ theme }) => breakpointFrom(theme.breakpoints.lg)} {
    ${({ theme }) => theme.typography.LrgBody1}
  }
  ${({ theme }) => breakpointFrom(theme.breakpoints.xl)} {
    ${({ theme }) => theme.typography.XLBody1}
  }
`

export type ValueTileProps = {
  icon: string
  heading: string
  description: string
}

export const ValueTile = ({ icon, heading, description }: ValueTileProps) => {
  return (
    <StyledWrapper>
      <StyledIlluWrapper>
        <SVG src={icon} />
      </StyledIlluWrapper>
      <StyledHeading>{heading}</StyledHeading>
      <StyledDescription>{description}</StyledDescription>
    </StyledWrapper>
  )
}
